/* eslint-disable global-require,import/no-unresolved,max-len,react/prefer-stateless-function */
import React from 'react'
import {
  ScrollView, Text, View,
} from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import * as RegionalLookup from '../methods/RegionalContentLookUp'

class WhereToPlaceMonitorPage extends React.Component {
  render() {
    const { t, regionalContentLookup } = this.props
    const nearBedsideKey = regionalContentLookup('nearBedside')
    return (
      <View style={{ flex: 1, backgroundColor: colors.bscBlue }}>
        <View style={{ flex: 1 }}>
          <ScrollView
            style={{ backgroundColor: colors.white }}
            testID="scrollview-WhereToPlaceMonitor"
          >
            <View style={styles.stepsContainer}>
              <Text style={[textStyles.h1, styles.shark_grey]}>
                {t('whereToPlaceTitle')}
              </Text>
            </View>
            <View style={{ padding: 16 }}>
              <Text style={textStyles.bodyContentText}>
                {t('nearPhoneJackAndOutlet')}
              </Text>
              <Text style={textStyles.bodyContentText} testID={nearBedsideKey}>
                {t(nearBedsideKey)}
              </Text>
              <Text style={textStyles.bodyContentText}>
                {t('canSitAndSee')}
              </Text>
              <Text style={textStyles.bodyContentText}>
                {t('dryPlace')}
              </Text>
            </View>
          </ScrollView>
        </View>
      </View>
    )
  }
}

WhereToPlaceMonitorPage.propTypes = {
  t: PropTypes.func.isRequired,
  regionalContentLookup: PropTypes.func.isRequired,
}

const actionCreators = {
  regionalContentLookup: RegionalLookup.regionalContentLookup,
}

export default withTranslation(['whereToPlaceMonitor'])(connect(null, actionCreators)(WhereToPlaceMonitorPage))
